import {
  forgetUpload,
  releasePreparedUploadResume,
  subscribeUploadEligibility,
  subscribeUploadSessionClear,
} from "../data-source/upload-payloads";

export function retainUploadRetry(
  id: string,
  retry: () => Promise<unknown>,
  setRetry: (retry?: () => Promise<unknown>) => void,
) {
  const retainedVersion = clearVersion;
  const resume = async () => {
    try {
      return await retry();
    } finally {
      if (releasePreparedUploadResume(id)) {
        if (retainedVersion === clearVersion) retainUploadRetry(id, retry, setRetry);
        else forgetUpload(id);
      }
    }
  };
  return subscribeUploadEligibility(id, (eligible) => setRetry(eligible ? resume : undefined));
}

let clearVersion = 0;
const clear = () => {
  clearVersion += 1;
};
window.addEventListener("pagehide", clear);
subscribeUploadSessionClear(clear);
